<template>
    <MainContent :title= "$t('campana_emails.crear_boletin')">
        <template v-slot:header>
            <h3 class="card-title mb-3">{{$t('campana_emails.crear_boletin')}}</h3>
        </template>
        <template v-slot:content>
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoDatos="{ changeStep }">
                    <PasoUnoComponent :boletin.sync="boletin" :loading="loading" @finalizarPasoUno="changeStep" />
                </template>
                <template #pasoDesign>
                    <PasoDosComponent :boletin.sync="boletin" :loading="loading" :error.sync="error" @finalizarPasoDos="crearBoletin" />
                </template>
            </Stepper>
        </template>        
    </MainContent>    
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import PasoUnoComponent from '@/components/backend/campana-emails/boletines/PasoUnoComponent';
    import PasoDosComponent from '@/components/backend/campana-emails/boletines/PasoDosComponent';

    export default {
        data() {
            return {
                boletin: {},
                loading: false,
                error: false
            }
        },
        computed: {
            steps() {
                return [
                    { label: this.$t('campana_emails.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('campana_emails.diseno'), slot: 'pasoDesign' }
                ]
            }
        },
        methods: {
            async crearBoletin() {
                this.loading = true;

                try {
                    const payload = {
                        asunto: this.boletin.asunto,
                        contenido: this.boletin.contenido,
                        remitente_id: this.boletin.remitente.id,
                        carpetas_comunicados: this.boletin.carpetas_comunicados?.map(c => c.id),
                        grupos_ids: this.boletin.grupos.map(g => g.id),
                        fecha_envio_programado: this.boletin.fecha_envio_programado
                    };
                    const response = await apiService.createBoletin(payload);
                    this.$toast.success('Boletín creado correctamente');
                    this.$router.push('/admin/emails/boletines');
                } catch (error) {
                    this.error = true;
                    console.error('Error al crear boletín:', error);
                    this.$toast.error('Error al crear boletín');
                } finally {
                    this.loading = false;
                }
            }
        },
        components: {
            Stepper, MainContent, PasoUnoComponent, PasoDosComponent
        }
    }
</script>